/**
 * goToSectionExtended action.
 */
import Pages from '@pages';
import { QuerySections } from '@shared/types/enums/sections';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';

export default function goToSectionExtended(railIndex?: number) {
  const { router } = store.getState();
  let section = null;

  // Fetch current query section
  switch (router.route.Page) {
    case Pages.MOVIES:
      section = QuerySections.MOVIES;
      break;
    case Pages.SERIES:
      section = QuerySections.SERIES;
      break;
    case Pages.SHOWS:
      section = QuerySections.SHOWS;
      break;
  }

  // Redirect to sectionExtended
  store.dispatch(
    pushRoute({
      route: { Page: Pages.SECTION_EXTENDED },
      params: {
        current: { section, rail: railIndex },
        push: true,
      },
    })
  );
}
